import * as yup from "yup";

import { APIMethods, ApiResponse } from "@typeDefinitions";
import { fetchData } from "@utils/api";

export const fetchDietsItemsProductsReplacement = async (
  dietId: string,
  from: string,
  to: string,
): Promise<ApiResponse<DietProductExchangeItemDto[]>> => {
  const response = await fetchData(
    `/dietitian/diets/${dietId}/items-products-replacement?from=${from}&to=${to}`,
    APIMethods.GET,
  );

  return responseSchema.validate(response);
};

type ExchangeType = "product" | "recipe";

interface TranslationLangDto {
  lang: string;
  name: string;
}

interface ItemDto {
  id: number;
  type: ExchangeType;
}

interface ItemDataDto {
  id: number;
  name: string;
  translations: TranslationLangDto[];
}

interface ProductItemDto extends ItemDto {
  type: "product";
  product: ItemDataDto;
}

interface RecipeItemDto extends ItemDto {
  type: "recipe";
  recipe: ItemDataDto;
}

interface MealDto {
  id: number;
  name: string;
  translations: TranslationLangDto[];
}

export interface DietProductExchangeItemDto {
  id: number;
  meal: MealDto;
  item: ProductItemDto | RecipeItemDto;
}

const translationLangSchema = yup.object({
  lang: yup.string().required(),
  name: yup.string().ensure(),
});

const itemDataSchema = yup.object({
  id: yup.number().required(),
  name: yup.string().required(),
  translations: yup.array().of(translationLangSchema).required(),
});

const mealSchema = yup.object({
  id: yup.number().required(),
  name: yup.string().required(),
  translations: yup.array().of(translationLangSchema).required(),
});

const productItemSchema = yup.object({
  id: yup.number().required(),
  type: yup.string<ExchangeType>().oneOf(["product"]).required(),
  product: itemDataSchema.required(),
});

const recipeItemSchema = yup.object({
  id: yup.number().required(),
  type: yup.string<ExchangeType>().oneOf(["recipe"]).required(),
  recipe: itemDataSchema.required(),
});

const dietProductExchangeItemSchema = yup.object({
  id: yup.number().required(),
  meal: mealSchema.required(),
  item: yup.lazy(value => {
    if (value?.type === "recipe") return recipeItemSchema.required();
    return productItemSchema.required();
  }),
});

const responseSchema = yup.object().shape({
  data: yup.array().of(dietProductExchangeItemSchema).required(),
});
